import {
    createFilterPill,
    FILTER_PILL_ITEM_STATE_CHECKED,
    FILTER_PILL_ITEM_STATE_CHECKED_DISABLED,
    FilterPill,
    FilterPillItemState,
    IFilterPillItem,
} from '@vfde-brix/ws10/filter-pill';
import {
    AbstractedUpsellCategory,
    UpsellFacetValue,
} from '@vfde-sails/glados-v2';
import { StateProps } from '../container/App/interfaces/state';
import { useDispatch } from '../store';
import {
    selectHasError,
    toggleCategory,
} from '../container/App/slice';
import {
    mapStateToProps,
    selectCategories,
} from '../container/App/selectors';
import { startAppListening } from '../container/App/listener';

/**
 * Mount filter pill component
 */
export default function mountFilterPill (id: string): FilterPill | null {
    const dispatch = useDispatch();

    const container = document.getElementById(id);
    const properties = {
        onClick: (categoryId: UpsellFacetValue) => dispatch(toggleCategory({
            value: categoryId,
        } as AbstractedUpsellCategory)),
    };

    const filterPill = container && createFilterPill(container, properties);

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectCategories(currentState) !== selectCategories(previousState),
        effect: (_action, api) => {
            api.cancelActiveListeners();

            const state = mapStateToProps(api.getState());

            const filterPillItems = convertApiCategoriesToFilterPillItems(state);

            filterPill?.update({
                listFilterPillItems: filterPillItems,
            });
        },
    });

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectHasError(currentState) !== selectHasError(previousState),
        effect: (_action, api) => {
            api.cancelActiveListeners();

            filterPill?.toggleContainer(selectHasError(api.getState()), true);
        },
    });

    return filterPill;
}

/**
 * Convert categories from API to filter pill properties
 */
export const convertApiCategoriesToFilterPillItems = (
    state: Pick<StateProps, 'categories' | 'selectedCategories' | 'isHardwareOnly' | 'isSimOnly'>,
): IFilterPillItem[] => {
    const { categories: categoriesFromApi, selectedCategories, isHardwareOnly, isSimOnly } = state;

    return categoriesFromApi!
        .filter(item =>
            (!isSimOnly || item.value === UpsellFacetValue.Redplus)
            && (!isHardwareOnly || item.value === UpsellFacetValue.Accessory),
        )
        .map(item => {
            let filterPillState: FilterPillItemState | undefined;

            switch (true) {
                case isHardwareOnly && item.value === UpsellFacetValue.Accessory:
                case isSimOnly && item.value === UpsellFacetValue.Redplus:
                    filterPillState = FILTER_PILL_ITEM_STATE_CHECKED_DISABLED;
                    break;
                case selectedCategories.some(category => category.value === item.value):
                    filterPillState = FILTER_PILL_ITEM_STATE_CHECKED;
                    break;
                default:
                    filterPillState = undefined;
                    break;
            }

            return {
                stdPillLabel: item.label,
                stdValue: item.value,
                optState: filterPillState,
                optIcon: window.additionalPageOptions.filterPill?.[item.value]?.icon,
            };
        })
    ;
};
